import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '../../config';
import { useFormConfig } from '../../hooks/useFormConfig';
import { resolveSelectedFormId } from '../../utils/form-id';

const DeclarationSuccessScreen = () => {
  const { tenant } = useFormConfig();
  const location = useLocation();
  const navigate = useNavigate();
  const stateFormId =
    typeof location.state === 'object' && location.state
      ? String((location.state as any).formId || '').trim()
      : '';
  const selectedFormId = stateFormId || resolveSelectedFormId(tenant, location.search || '');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search || '');
    if (selectedFormId) {
      searchParams.set('formId', selectedFormId);
    }
    navigate(
      `/${tenant}/${config.urls.summary}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`,
      { replace: true },
    );
  }, [location.search, navigate, selectedFormId, tenant]);

  return null;
};

export default DeclarationSuccessScreen;
